<template>
    <UserDetail
        v-if="loaded && user"
        :user="user"
        :user-roles="userRoles"
        :password-min-length="passwordMinLength"
        :customers="customers"
        :designers="designers"
        :user-added="userAdded"
        @updateUser="updateUser"
        @createAdditionalUser="createAdditionalUser"
        @searchDesigners="executeSearchDesigners"
        @searchCustomers="executeSearchCustomers"
    />
    <Page404 v-else-if="loaded" message="That user was not found" />
</template>
<script>
import { mapActions } from "vuex";
import Page404 from "src/components/NotFoundPage.vue";
import UserDetail from "./_components/UserDetail.vue";
import api from "src/services/api.js";
import { mutations } from "src/global-store.js";

export default {
    name: "UserDetailModule",
    components: {
        UserDetail,
        Page404,
    },
    data() {
        return {
            loaded: false,
            firstLoad: true,
            shouldNotify: true,
            userAdded: false,
            customers: [],
            designers: [],
            user: null,
            passwordMinLength: 6,
            userRoles: [
                "ClientBasic",
                "ClientAdmin",
                "CompanyBasic",
                "CompanyAdmin",
                "Developer",
            ],
        };
    },
    async created() {
        try {
            this.user = await api.get("/users/" + this.$route.params.id);
        } catch (error) {
            console.error(error);
        }
        mutations.setNavbarTitle(
            this.user.first_name + " " + this.user.last_name,
            this.user.customer_name,
        );
        this.loaded = true;
    },
    beforeDestroy() {
        // clear all the notifications related to this module
        this.$notifications.removeAll();
    },
    methods: {
        ...mapActions("customer", ["searchCustomers"]),
        ...mapActions("designer", ["searchDesigners"]),
        async updateUser(update) {
            try {
                await api.patch("/users/" + this.$route.params.id, update);
                this.user = { ...this.user, ...update };
            } catch (error) {
                console.error(error);
            }
        },
        async createAdditionalUser(user) {
            try {
                await api.post("/users", user);
                this.userAdded = true;
            } catch (error) {
                console.error(error);
            }
        },
        async executeSearchCustomers({ search, loading }) {
            loading(true);
            this.customers = await this.searchCustomers(search);
            loading(false);
        },
        async executeSearchDesigners({ search, loading }) {
            loading(true);
            this.designers = await this.searchDesigners(search);
            loading(false);
        },
    },
};
</script>
